import { PaymentTerm } from 'src/types/enums';
import { SelectWithLabel } from './SelectWithLabel';

export interface IPaymentTerm {
  code: PaymentTerm;
  value: string;
  days: number;
}

export const paymentTerms: IPaymentTerm[] = [
  { code: PaymentTerm.Pc7, value: 'Contant 7 dagen', days: 7 },
  { code: PaymentTerm.P14, value: '14 dagen', days: 14 },
  { code: PaymentTerm.P14E, value: '14 dagen einde maand', days: 14 },
  { code: PaymentTerm.P21, value: '21 dagen', days: 21 },
  { code: PaymentTerm.P21E, value: '21 dagen einde maand', days: 21 },
  { code: PaymentTerm.P30, value: '30 dagen', days: 30 },
  { code: PaymentTerm.P30E, value: '30 dagen einde maand', days: 30 },
  { code: PaymentTerm.P45, value: '45 dagen', days: 45 },
  { code: PaymentTerm.P60, value: '60 dagen', days: 60 },
  { code: PaymentTerm.P60E, value: '60 dagen einde maand', days: 60 },
  { code: PaymentTerm.P90, value: '90 dagen', days: 90 },
];

export const defaultPaymentTerm = paymentTerms.find((term) => term.code === PaymentTerm.P30)!;

export const SelectPaymentTerm = (props: {
  name: string;
  value: IPaymentTerm;
  onChange: (value: IPaymentTerm) => void;
}) => {
  const { name, value, onChange } = props;

  return (
    <SelectWithLabel
      name={name}
      isOptional={false}
      labelText="Betaaltermijn"
      items={paymentTerms}
      keyName="value"
      selectedItem={value}
      onSelect={(v) => (v ? onChange(v) : onChange(value))}
      display={(x) => x.value}
    ></SelectWithLabel>
  );
};
